import React, { useEffect, useState } from "react";
import { Button } from "antd";
import Cookies from "js-cookie";
import { ReactSVG } from "react-svg";
import moment from "moment";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";

import { DATE_FORMAT_FRONTEND } from "../../constants";
import { getTranslation } from "../../utils/helper";

import { doDetailRoutePlan } from "../../modules/routePlan/api";

const RoutePlanCurrent = ({ routePlanT, onClickRoute }) => {
  const user = useSelector(state => state.auth.user);
  const setting = user.company;
  const currentRoutePlan = Cookies.get(`currentRoutePlan-${user._id}`);
  const [routePlan, setRoutePlan] = useState(routePlanT);

  useEffect(() => {
    if (routePlanT?._id) {
      setRoutePlan(routePlanT);
    }
  }, [routePlanT]);

  useEffect(() => {
    const fetchData = async () => {
      if (currentRoutePlan && routePlan?._id) {
        const response = await doDetailRoutePlan(routePlan._id);
        if (response?.response) {
          setRoutePlan(response.response);
        }
      }
    };
    fetchData();
  }, [currentRoutePlan, routePlan?._id]);

  if (!currentRoutePlan) {
    return <></>;
  }

  if (!routePlan || !routePlanT || routePlan._id !== routePlanT._id) {
    return <></>;
  }

  return (
    <div className="CurrentRoutePlan">
      <div>
        {getTranslation(setting, "Common", "Current Route Plan")}: <span>{routePlan.name}</span>
      </div>
      <div className="right">
        <div>
          <label>{getTranslation(setting, "Common", "Date")}:</label>{" "}
          <span>{moment(routePlan.deliveryDate).utc().format(DATE_FORMAT_FRONTEND)}</span>
        </div>
        <div>
          <label>{getTranslation(setting, "Common", "Stops")}:</label> <span>{routePlan.orders.length}</span>
        </div>
        <div>
          <label>{getTranslation(setting, "Common", "Drivers")}:</label> <span>{routePlan.drivers.length}</span>
        </div>
        <div>
          <span className={"status routePlanStatus " + routePlan.status.toLowerCase()}>
            {getTranslation(setting, "Route Plans", routePlan.status)}
          </span>
        </div>
        <div>
          <Link to={"/route-plans/" + routePlan._id}>
            <Button>
              {getTranslation(setting, "Common", "View")}
              <ReactSVG className="icon" src="/icons/arrow-view.svg" />
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default RoutePlanCurrent;
